import RolloverMenu from '../../../../../../../com/rolloverMenu/RolloverMenu'

import {history} from '../../../../../../../helpers/history';

import {useDispatch} from 'react-redux';
import {actionCreators} from '../../../../../../../store';

import {UserDto} from "../../../../../../../dtos";
import {useEffect, useState} from "react";
import {Box} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {OrangeButton} from "../../../../../../com/pagesTab/orangeBtn/OrangeButton";
import {resetFlyerState} from "../../../../../../../store/actionCreators/flippingFlyerActionCreators";
import {clearFlyersData} from "../../../../../../../store/actionCreators/flyersActionCreators";

const useStyles = makeStyles(() => ({
    muiBox: {
        // lineHeight: '24px',
        // minWidth: '160px',
        // width:'fit-content',
        whiteSpace: 'nowrap',
        '&.buttonWrapper': {
            justifyContent: 'end',
            display: 'flex',
            width: '100%'
        }
    },
}));

interface IUserControlsMenu {
    target: any;
    onHide: () => void;
    openChangePasswordPopup: VoidFunction;
}

const UserControlsMenu: React.FC<IUserControlsMenu> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [userFullName, setUserName] = useState<string>('')
    const [userCompany, setUserCompany] = useState<string>('');
    const [userEmail, setUserEmail] = useState<string>('')
    const handleSignout = () => {
        dispatch(actionCreators.logout());
        dispatch(resetFlyerState());
        dispatch(clearFlyersData());
        history.push('/auth/flyersCatalog/signInForm')
        /*
                if (history.location.pathname.indexOf('/flipbookEditor') > -1) {
                    history.push('/auth/flipbookEditor/signInForm')
                } else {
                    history.push('/auth/flyersCatalog/signInForm')
                }
        */
    }

    useEffect(() => {
        let userDtoStr = localStorage.getItem('userDto')
        if (userDtoStr) {
            let userDto: UserDto = JSON.parse(userDtoStr);
            setUserName(`${userDto.firstName} ${userDto.lastName}`);
            setUserCompany(`${userDto.company}`);
            setUserEmail(`${userDto.emailAddress}`)
        }

    }, [])

    return (
        <>
            <RolloverMenu
                show={true}
                target={props.target}
                onHide={() => props.onHide()}
                placement="bottom"
            >
                <Box
                    sx={{
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "12px"
                    }}
                >
                    <Box className={classes.muiBox}>{`${userCompany} - ${userFullName}`}</Box>
                    <Box className={classes.muiBox}>{`${userEmail}`}</Box>
                    <Box className={`${classes.muiBox} buttonWrapper`}>
                        <OrangeButton buttonName={`Change My Password`} onClick={props.openChangePasswordPopup}/>
                    </Box>
                    <Box className={`${classes.muiBox} buttonWrapper`}>
                        <OrangeButton buttonName={`Sign Out`} onClick={handleSignout} width={100}/>
                    </Box>

                </Box>

            </RolloverMenu>
        </>
    );
}

export default UserControlsMenu;